<template>
  <!-- SIDEBAR COMPONENTS -->
  <LoaderComponents
    v-editor-target="'sidebar_components'"
    class="space-y-7"
    :components="data"
  />
</template>

<script setup lang="ts">
defineProps({
  data: {
    type: Object, required: true,
  },
})

provide('isSidebar', true)
</script>
